<template>
	<div>
		<div style="padding: 20px 70px;background: #F0F0F0;display: flex;align-items: center;">
			<div class="el-icon-success" style="font-size: 55px;color: #1677FF;margin-right: 15px;"></div>
			<div style="font-size: 14px;line-height: 32px;">
				<div>您的订单已提交成功！请尽快付款</div>
				<div>金额：<span style="color: orange;font-size: 18px;">￥{{orderPrice}}</span></div>
			</div>
		</div>
		<div style="padding: 20px 70px;">
			<div style="font-weight: bold;">请选择支付方式</div>
			<el-radio-group v-model="payment" style="display: flex;margin-top: 15px;">
				<el-radio :label="item.type" v-for="(item, index) in paymentList" :key="index"
					style="display: flex;align-items: center;border: 1px solid #F0F0F0;padding: 10px 20px;border-radius: 5px;">
					<div :class="item.type == 'ali' ? 'ali-pay' : 'wx-pay'" class="pay"></div>
				</el-radio>
			</el-radio-group>
		</div>
		<div style="padding: 20px 70px;">
			<el-button type="primary" @click="paymentHandle">立即支付</el-button>
			<el-button>返回订单</el-button>
		</div>
		<div v-html="aliHtml"></div>
		<el-dialog custom-class="payWX" class="alipay" :visible.sync="payDialog" title="扫码支付"  :append-to-body="true" :before-close="handleClose"
			width="500px">
			<div class="qCode">
				<div style="display: flex;align-items: center;justify-content: space-around;">
					<div>
						<img class="code" :src="wxPayUrl" style="width: 12.5rem;height: 12.5rem;">
						<div style="display: flex;align-items: center;justify-content: center;margin-top: -10px;margin-bottom: 30px;font-size: 20px">
							<img src="../assets/imgs/wxpay.png" style="width: 1.25rem;height: 1.25rem;margin-right: 0.3125rem;" />
							<div>微信支付</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {aliPay, wxPay, checkOrderResult} from "@/api/orderApi"
	export default {
		data() {
			return {
				orderSn: '',
				orderPrice: 0,
				payment: null,
				paymentList: [{
					label: '支付宝',
					type: 'ali'
				}, {
					label: '微信',
					type: 'wx'
				}],
				aliHtml: '',
				payDialog: false,
				aliPayUrl: "",
				wxPayUrl: "",
				chatTimer: null
			}
		},
		created() {
			this.init()
		},
    deactivated() {
      this.$destroy();
    },
    methods: {
			paymentHandle() {
				// 如果为微信，则进行二维码
				if (this.payment == 'wx') {
					wxPay({'orderSn': this.orderSn}).then((res) => {
						this.wxPayUrl = res.data.wxQrCodeUrl
						this.payDialog = true
						this.chatTimer = setInterval(() => {
              //每隔3秒查询用户是否支付
							this.checkPay(res.data)
						}, 3000)
					})
				}
				// 如果为支付宝，则进行element填充
				else if (this.payment == 'ali') {
					aliPay({'orderSn': this.orderSn}).then((res) => {
						this.aliHtml = res.data.aliHtml
						setTimeout(function() {
							document.forms[0].submit();
						}, 500)
					})
				}
			},
			// 查询订单是否支付成功
			checkPay(paramsData) {
				setTimeout(() => {
					checkOrderResult({
						orderId: paramsData.orderNo
					}).then(response => {
						const res = response
						if (res.code === 200) {
							if (res.msg === '1') {
								this.$message({
									message: '支付成功！',
									type: 'success'
								})
								this.handleClose()
								clearInterval(this.chatTimer)
								this.$router.push({
									path: "/profile"
								});
							}
						} else {
							clearInterval(this.chatTimer)
							this.$message({
								message: res.message,
								type: 'error'
							})
						}
					})
				}, 0)
			},
			handleClose() {
				clearInterval(this.chatTimer)
				this.aliPayUrl = ""
				this.wxPayUrl = ""
				this.payDialog = false
			},
			init() {
				let order = JSON.parse(localStorage.getItem("order"))
				this.orderPrice = order.orderPrice
        this.orderSn = order.orderSn
			}
		},
	}
</script>

<style scoped>
	.pay {
		width: 140px;
		height: 55px;
	}
   /deep/ .payWX .el-dialog__body{
    padding: 10px 20px;
  }
	.ali-pay {
		margin-left: 10px;
		background-image: url(../assets/imgs/zhifubao.png);
		background-repeat: no-repeat;
		background-size: 100%;
	}

	.wx-pay {
		margin-left: 10px;
		background-image: url(../assets/imgs/wxpay1.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 200px;
	}
</style>